function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import moment from 'moment';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import { FormattedMessage } from 'react-intl';
import map from 'lodash/map';
import ActivityIcon from 'svg/mobileReports/activity.svg';
import MealIcon from 'svg/mobileReports/meal.svg';
import InjectionIcon from 'svg/mobileReports/injection.svg';
import AverageIcon from 'svg/mobileReports/average-blood.svg';
import messages from '../../../../messages';
import Marker from '../../Marker';
import UnitSymbolAsFraction from '../../../UnitSymbolAsFraction';
import styles from './Annotations.pcss';
const rowDetails = [
    {
        type: 'bgm',
        Icon: AverageIcon,
        renderLabel: (conversion)=>/*#__PURE__*/ _jsxs("span", {
                className: styles.labelInner,
                children: [
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.bgm)),
                    " (",
                    /*#__PURE__*/ _jsx(UnitSymbolAsFraction, {
                        unitSymbol: conversion.unitSymbol
                    }),
                    ")"
                ]
            }),
        renderSummary: ({ averageValue }, conversion)=>/*#__PURE__*/ _jsxs("div", {
                className: styles.avarageSummary,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.avarageSummary__text,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.summaries.average))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.avarageSummary__value,
                        children: ` ${averageValue ? (+averageValue).toFixed(conversion.unit === 'MG_DL' ? 0 : 1) : '-'}`
                    })
                ]
            })
    },
    {
        type: 'foods',
        Icon: MealIcon,
        renderLabel: (conversion, carbsConversion)=>/*#__PURE__*/ _jsxs("span", {
                className: styles.labelInner,
                children: [
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.carbs)),
                    " (",
                    carbsConversion.unitSymbol,
                    ")"
                ]
            }),
        renderSummary: ({ foodValues })=>/*#__PURE__*/ _jsx("span", {
                children: /*#__PURE__*/ _jsx(Marker, {
                    type: "food",
                    value: foodValues
                })
            })
    },
    {
        type: 'medications',
        Icon: InjectionIcon,
        renderLabel: ()=>/*#__PURE__*/ _jsxs("span", {
                className: styles.labelInner,
                children: [
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.injection)),
                    ' ',
                    "(",
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.injectionUnit)),
                    ")"
                ]
            }),
        renderSummary: ({ medicationFastValues, medicationLongValues })=>{
            if (medicationFastValues === '0.0' && medicationLongValues === '0.0') return null;
            return /*#__PURE__*/ _jsx("span", {
                children: /*#__PURE__*/ _jsx(Marker, {
                    type: "overlapingInjections",
                    values: [
                        medicationFastValues,
                        medicationLongValues
                    ]
                })
            });
        }
    },
    {
        type: 'activities',
        Icon: ActivityIcon,
        renderLabel: ()=>/*#__PURE__*/ _jsxs("span", {
                className: styles.labelInner,
                children: [
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.activity)),
                    ' ',
                    "(",
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.activityUnit)),
                    ")"
                ]
            }),
        renderSummary: ({ activityValues })=>/*#__PURE__*/ _jsx("span", {
                children: /*#__PURE__*/ _jsx(Marker, {
                    type: "activity",
                    value: activityValues
                })
            })
    }
];
const Day = ({ dayTimestamp })=>{
    const date = moment.unix(dayTimestamp);
    return /*#__PURE__*/ _jsxs("h3", {
        className: cn(styles.day),
        children: [
            date.format('ddd'),
            ", ",
            date.format('MMM DD')
        ]
    });
};
const Labels = ({ dayTimestamp, conversion, carbsConversion, isFirstDay })=>{
    useStyles(styles);
    const renderRowLabel = (type, Icon, renderLabel = null)=>/*#__PURE__*/ _jsxs("div", {
            className: styles.label,
            children: [
                renderLabel && renderLabel(conversion, carbsConversion),
                /*#__PURE__*/ _jsx(Icon, {
                    className: styles[`icon--${type}`]
                })
            ]
        }, type);
    if (isFirstDay) {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.labels,
            children: [
                /*#__PURE__*/ _jsx(Day, {
                    dayTimestamp: dayTimestamp
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.labelContainer,
                    children: map(rowDetails, ({ type, renderLabel, Icon })=>renderRowLabel(type, Icon, renderLabel))
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.labels,
        children: [
            /*#__PURE__*/ _jsx(Day, {
                dayTimestamp: dayTimestamp
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.labelContainer,
                children: map(rowDetails, ({ type, Icon })=>renderRowLabel(type, Icon, null))
            })
        ]
    });
};
const Summaries = ({ isFirstDay, relatedValues, conversion })=>{
    useStyles(styles);
    const renderRowSummary = (type, Icon, renderSummary = null)=>/*#__PURE__*/ _jsxs("div", {
            className: styles.summary__row,
            children: [
                /*#__PURE__*/ _jsx(Icon, {
                    className: styles[`icon--${type}`]
                }),
                renderSummary(relatedValues, conversion)
            ]
        }, type);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.summary,
        children: [
            isFirstDay && /*#__PURE__*/ _jsx("h3", {
                className: styles.summary__header,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.summaries.dailySummary))
            }),
            map(rowDetails, ({ type, renderSummary, Icon })=>renderRowSummary(type, Icon, renderSummary))
        ]
    });
};
export { Labels, Summaries };
